import React, { Component } from 'react';
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer } from 'recharts';
import { Card, Row, Col, Button } from 'reactstrap';
import { OVERALL, PAYMENT_SCORE } from '../constants';
import { getFilterType } from "./util";
import ChartDescriptorPopover from './chart-descriptor-popover';
import {PAYMENT_SCORE_DESCRIPTION} from '../constants';

class LineChartComponent extends Component {

  state = {
    lineChartProperties: {
      with_me_color: '#203864', with_cug_member_color: '#ff0000', cug_group_color: '#ffff00', portfolio_color: '#35e33d'
     
    },
    selectedfilter: OVERALL
  }

  componentDidMount() {
   
    if (this.props.chartData) {
      this.setState({ chartData: this.props.chartData }, ()=>{
        setTimeout( ()=> this.filterData(), 2500);
      })
    }
  }

  handleTypeFilter = (e) => {
    if (this.state.selectedfilter !== e.target.value) {
      this.setState({ selectedfilter: e.target.value }, ()=>{
        this.filterData();
      })
    }
    e.preventDefault();
  }

  filterData = () => {
    let type = getFilterType(this.state.selectedfilter);
    let filteredData = this.props.chartData.filter(objdata => objdata.type == type);
    this.setState({ filteredData: filteredData })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.chartData !== this.props.chartData){
      this.filterData();
    }
  }

  descriptionPopoverToggle = (event) => {
    this.props.descriptionPopoverToggle((event.target.tagName == 'BUTTON') ? event.target.id : event.target.parentNode.id, PAYMENT_SCORE)
  }

  render() {
    return (
        <Card body>
          <div>
            <h3 className='text-center'>
              {PAYMENT_SCORE}
              {/* <Button size="sm" color="link" onClick={this.descriptionPopoverToggle} id="Popover1">
                <i className="icon-info"></i>
              </Button> */}
            </h3>
            
            {
              this.props.typeFilters 
              && this.props.typeFilters.length > 0 
              && <select className='position-absolute chart-filter-dropdown' name="typefilter" onChange={(e) => this.handleTypeFilter(e)}  value ={ this.state.selectedfilter  }>
                {this.props.typeFilters.map(optionValue => (<option key={Math.random()} value={optionValue} >{optionValue}</option>))}
              </select>
            }
          </div>
          <ResponsiveContainer width='100%' height={300}>
            <LineChart data={this.state.filteredData} 
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}  >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend style={{ marginTop: `5px !important` }} />
              <Line type="monotone" dataKey="me" stroke={this.state.lineChartProperties.with_me_color} name={`${this.props.counterpartyName} (With me)`} strokeWidth={2} />
              <Line type="monotone" dataKey="cug_member" stroke={this.state.lineChartProperties.with_cug_member_color} name={`${this.props.counterpartyName} (With Other CUG Members)`} strokeWidth={2} />
              <Line type="monotone" dataKey="portfolio" stroke={this.state.lineChartProperties.portfolio_color} name={`${this.props.corporateName} Portfolio`} strokeWidth={2} />
              <Line type="monotone" dataKey="cug" stroke={this.state.lineChartProperties.cug_group_color} name={"CUG Group"} strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>

          <details>
            <summary>
              <i>Know more...</i>
            </summary>
            <p dangerouslySetInnerHTML={{ __html: PAYMENT_SCORE_DESCRIPTION }}></p>
          </details>
          
        </Card>
    );
  }
}

export default LineChartComponent;